import { Component } from '@angular/core';
import { OnboardingUserService } from "../onboardingUserForgerock/onboard-user.service";
import { ApiResponse } from '../../models/api-response';
import { NotificationService } from "../../services/notification.service";
import { OnboardingUserDetails } from './onboard-user-details';
import { OnboardUserRequest } from './onboard-user-request';
import any = jasmine.any;

@Component({
    selector: 'onboard-user',
    template: require('./onboard-user.component.html')
})
export class OnboardingUserComponent {

    userName: string;
    firstName: string;
    lastName: string;
    emailId: string;
    phoneNumber: string;
    userId: string;
    systemType: string = "sample-device";
    loginUrl: string;
    redirectUrl: string;
    applicationName: string;
    areBothUserAndApplicationCreationSuccess = false;
    isUserCreationSuccess = false;
    isApplicationCreationSuccess = false;
    responseData: any;
    detailsRetrieved = false;
    retrievedUserDetails: OnboardingUserDetails = new OnboardingUserDetails('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');

    emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    guidValidatorRegex: RegExp = new RegExp('^[{(]?[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$');
    constructor(private onboardingUser: OnboardingUserService,
        private notifier: NotificationService) {
        this.notifier.clear();
    }

    clearMessages() {
        this.areBothUserAndApplicationCreationSuccess = false;
        this.isUserCreationSuccess = false;
        this.isApplicationCreationSuccess = false;
        this.notifier.clear();
    }
    typeCastResponse(response: any): OnboardingUserDetails {

        if (response.statusCode === 200) {
            var retrievedUserDetails = (<OnboardingUserDetails>(<ApiResponse>(response)).data);

            return retrievedUserDetails;

        }
        this.notifier.displayError(response.data.value);
        return new OnboardingUserDetails('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
    }

    onboardUser() {
        this.clearMessages();

        if (this.applicationName == null) {
            this.applicationName = this.userName + ".app";
        }
        if (this.firstName == null || this.lastName == null || this.userName == null || this.phoneNumber == null || this.emailId == null || this.systemType == null || this.loginUrl == null || this.redirectUrl == null || this.applicationName == null) {
            this.notifier.displayError("Fields cannot be left empty. Please try again with a valid input.");
            return;
        }

        this.notifier.displayInfo("Attempting to onboard User to ForgeRock..");
        var onboardUserRequest = new OnboardUserRequest(this.userName,
            this.firstName,
            this.lastName,
            this.emailId,
            this.phoneNumber,
            this.systemType,
            this.loginUrl,
            this.redirectUrl,
            this.applicationName
        );
        this.onboardingUser.onboardUser(onboardUserRequest).subscribe(
            resp => {
                this.notifier.clear();
                this.notifier.displaySuccess("Successfully created Application and User in Forgerock. And the user is added to default groups. Details: ");
                this.responseData = resp;
                if (this.responseData) {
                    this.assignOutput(this.responseData);
                    this.retrievedUserDetails = this.typeCastResponse(this.responseData);
                }
            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }


    assignOutput(response: any) {
        this.applicationName = null;
        if (response.data.statusCodeResponse.userCreationResponse === "Successful" && response.data.statusCodeResponse.applicationCreationResponse === "Successful") {
            this.areBothUserAndApplicationCreationSuccess = true;
        }
        else if (response.data.statusCodeResponse.userCreationResponse === "Successful") {
            this.isUserCreationSuccess = true;
        }
        else if (response.data.statusCodeResponse.applicationCreationResponse === "Successful") {
            this.isApplicationCreationSuccess = true;
        }
    }


}


/** WEBPACK FOOTER **
 ** ./app/main/onboardingUserForgerock/onboard-user.component.ts
 **/